module.exports = __webpack_public_path__ + "static/img/background.4c0f8feb.svg";